import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { httpOptions } from 'src/app/submodules/angular-common/http-util';
import { buildUrl } from 'submodules/engine-common/util';
import { fileTransfer, FileTransfer } from 'src/app/submodules/angular-common/util';

@Injectable()
export class SignUpStep2Service {

    constructor(
        private _injector: Injector,
        private _httpClient: HttpClient,
    ) { }


    signUpObs(otp , password, passwordConfirmation, username, recaptchaToken?): Observable<any> {

        return this._httpClient.post(
            buildUrl(this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["v1", "sign-up"]),
            {
                'otp': otp,
                'password': password,
                'password-confirmation': passwordConfirmation,
                'username': username,
                'recaptcha-token': recaptchaToken
            })
    }

    signUp = async (otp,password, passwordConfirmation, username, recaptchaToken?): Promise<any> => this.signUpObs(otp , password, passwordConfirmation, username, recaptchaToken).toPromise()



    checkOtpObs(otp): Observable<any> {

        return this._httpClient.get(
            buildUrl(this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["v1", "check-sign-up-otp"],
                [`otp=${otp}`]),
           )
    }

    checkOtp = async (otp): Promise<any> => this.checkOtpObs(otp).toPromise()




}
